"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  FooterApp: true,
  FooterAppSkeleton: true,
  FooterErrorBoundary: true
};
Object.defineProperty(exports, "FooterApp", {
  enumerable: true,
  get: function () {
    return _App.App;
  }
});
Object.defineProperty(exports, "FooterAppSkeleton", {
  enumerable: true,
  get: function () {
    return _containers.FooterAppSkeleton;
  }
});
Object.defineProperty(exports, "FooterErrorBoundary", {
  enumerable: true,
  get: function () {
    return _containers.ErrorBoundary;
  }
});
var _App = require("./App");
var _constantsGenerated = require("./constants-generated");
Object.keys(_constantsGenerated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constantsGenerated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constantsGenerated[key];
    }
  });
});
var _containers = require("./containers");
var _defaultTranslations = require("./constants/defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _defaultTranslationsWithNamespaces = require("./constants/defaultTranslationsWithNamespaces");
Object.keys(_defaultTranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultTranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslationsWithNamespaces[key];
    }
  });
});
